export function getBadgeStatus() {
    return {
        Class(status) {
            switch (status) {
                case 1: //Active
                case 'Active':
                case 'Completed':
                    return 'badge-status-active';
                case 2: //Inactive
                case 'Inactive':
                case 'Not Started':
                    return 'badge-status-inactive';
                case 3: //In Progress
                case 'In Progress':
                case 'Processing':
                case 'Queued':
                case 'Completed With Errors':
                    return 'badge-status-inprogress';
                case 4: //Pending
                case 'Error':
                case 'Pending':
                    return 'badge-status-pending';
                default:
                    return '';
            }
        },
        SVGColor(status) {
            switch (status) {
                case 1: //Active
                case 'Active':
                case 'Completed':
                    return '#14BA6D';
                case 2: //Inactive
                case 'Inactive':
                case 'Not Started':
                    return '#667085';
                case 3: //In progress
                case 'In Progress':
                case 'Processing':
                case 'Queued':
                case 'Completed With Errors':
                    return '#FFA800';
                case 4: //Pending
                case 'Error':
                case 'Pending':
                    return '#EF4E45';
                default:
                    return '';
            }
        },
        PortalStatusString(status) {
            switch (status) {
                case 1: //Active
                    return 'Active';
                case 2: //Inactive
                    return 'Inactive';
                case 3: //Draft, formerly known as "In Progress"
                    return 'Draft';
                case 4: //Pending
                    return 'Pending';
                case 5:
                    return 'Error';
                default:
                    return '';
            }
        },
    };
}
